<script setup>
import { formattedDate, swalError } from '@/helper';
import { retrieve_child } from '@/services/child';
import { onMounted, ref } from 'vue';

const props = defineProps({
  child_id: {
    required: true
  }
})

const isLoading = ref(true)
const child = ref({})
onMounted(async()=>{
  await get_child_subscription()
  isLoading.value = false
})

async function get_child_subscription(){
  let response = await retrieve_child(props.child_id, '?subscription=true&subscription_data=true')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data.included?.length != 0){
    child.value = parseSubscription(response.result.data)
    // console.log("🚀 ~ get_child_subscription ~ child.value:", child.value)
    isEmpty.value = false
  }
}

function parseSubscription(result){
  let tempChild = result.data
  let child_subscriptions = result.included.filter(item => item.type == 'child_subscription')
  child_subscriptions.forEach(childSub => {
    childSub.subscription = result.included.filter(item=>item.type == 'subscription')
                                            .find(sub => childSub.attributes.subscription_id == sub.id)
  });
  child_subscriptions.sort((a, b) => new Date(a.attributes.created_at) - new Date(b.attributes.created_at))
  tempChild.subscriptions = child_subscriptions
  return tempChild
}
const isEmpty = ref(true)
</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <h5 class="m-0">Subscribed Package</h5>
    </div>
    <div class="card-body pt-0">
      <div v-if="isEmpty">
        <p>No subcscription for this child yet</p>
        <router-link class="btn btn-light-primary"
          :to="{name: 'subscription'}"
        >
          Subscribe Now
        </router-link>
      </div>
      <div v-else>
        <template v-for="sub in child.subscriptions" :key="sub.id">
          <div class="mb-2">
            <p class="d-flex align-items-center">
              {{ sub.subscription.attributes.title }} 
              <span class="ms-2 badge text-capitalize"
                :class="sub.attributes.status == 'active' ? 'badge-light-success' : 'badge-light-danger' "
              >
                {{ sub.attributes.status }}
              </span> 
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>